import { Box, Button, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AxiosConfig from '../../../../../../config/AxiosConfig';
import LoadingButton from '../../../../utils/common/LoadingButton';

const GenerateModeration = (props) => {
  const {
    ticket,
    handleCloseModeration,
    moderationData,
    // mutate,
    // mutateTicket,
  } = props;
  const navigate = useNavigate();
  const profile = useSelector((state) => state?.login?.profile);
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleTextFieldChange = (e) => {
    setContent(e.target.value);
  };

  const handleConfirmModeration = (_e) => {
    const messageContent = `${
      moderationData?.content?.length > 0
        ? '=== Info. Qualification===\n' + moderationData?.content
        : ''
    }=== Message ===\n${content}`;
    setIsLoading(true);
    AxiosConfig.create('post', `/tickets/${ticket?._id}/askModeration`)
      .call({
        userId: profile?._id,
        content: messageContent,
        service: moderationData?.service,
        ticketType: moderationData?.ticketType,
      })
      .exit((_res) => {
        handleCloseModeration();
        navigate('/inbox');
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <Box>
        <Typography
          component={'span'}
          sx={{ margin: 1, marginTop: 0 }}
          fontSize={10}
        >
          Demande de modération
        </Typography>
        <TextField
          id="filled-textarea"
          label="Motif de la demande"
          placeholder="Ecrire le motif..."
          multiline
          sx={{ width: '50%', padding: 1 }}
          rows={3}
          onChange={handleTextFieldChange}
          variant="filled"
        />
      </Box>
      <Box>
        <Button
          variant="contained"
          onClick={handleCloseModeration}
          color="warning"
          size="small"
        >
          Annuler
        </Button>
        <LoadingButton
          isLoading={isLoading}
          variant="contained"
          onClick={handleConfirmModeration}
          color="success"
          size="small"
          disabled={!(content?.length > 0)}
        >
          Valider
        </LoadingButton>
      </Box>
    </>
  );
};

export default GenerateModeration;
